import React, { useState } from "react";
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import ReactTable from "../../components/constantComponent/reactTable/ReactTable";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";
import { useTranslation } from "react-i18next";
import {
	ApiKey,
	ApiUrl,
	LanguageKey,
	_TRANSACTION_STATUS,
	_WALLET_GAME_TRANSACTION_TYPE,
	Transaction,
} from "../../util/Constant";
import {
	stringIsNullOrEmpty,
	numberWithCurrencyFormat,
} from "../../util/Util";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { setBusy, setIdle, showMessage } from "../../redux/AppAction";
import { useDispatch, useSelector } from "react-redux";
import ApiEngine from "../../util/ApiEngine.js";
import {
	Panel,
	PanelHeader,
	PanelBody,
} from "./../../components/panel/panel.jsx";
import { useHistory } from "react-router-dom";

/// <summary>
/// Author : -
/// </summary>

const MemberAccountJourney = (props) => {
	const { register, handleSubmit, errors, setValue, trigger } = useForm();
	const _userData = useSelector(state => state.authState.userData);
	const _dispatch = useDispatch();
	let _history = useHistory();
	const { t } = useTranslation(LanguageKey._PRIMARY);
	const [startDate, setStartDate] = useState(
		moment().add(-1,"days").startOf("day").format("YYYY-MM-DD HH:mm:ss")
	);
	const [endDate, setEndDate] = useState(
		moment().endOf("day").format("YYYY-MM-DD HH:mm:ss")
	);
	const [memberId, setMemberId] = useState("");
	const [reportData, setReportData] = useState([]);
	const [exportDatas2, setExportDatas2] = useState([]);
	const [username, setUsername] = useState("");

	let _tableColumns = [
		{
			Header: t("DATE"),
			accessor: "transactionDateTime",
			sortType: (rowA, rowB) => {
				const dateA = moment(rowA.original.transactionDateTime);
				const dateB = moment(rowB.original.transactionDateTime);
				return dateA - dateB;
			},
			Cell: ({ row }) => {
				return <span>{moment(row.original.transactionDateTime).format("YYYY-MM-DD HH:mm:ss")}</span>;
			},
			disableSortBy: true,
		},
		//{
		//	Header: t("DESCRIPTION"),
		//	accessor: "action",
		//	disableSortBy: true,
		//},
		{
			Header: () => {
				return <div className="pull-right">{t("DESCRIPTION")}</div>;
			},
			accessor: "action",
			Cell: ({ row }) => {
				return <><div className="pull-left" dangerouslySetInnerHTML={{ __html: row.original.action }} ></div>
					{row.original.remark != null &&
						<div className="pull-left" style={{ display: "grid" }}>
							<div className="pull-left error-text" >{t("ERROR")}:</div><div className="pull-left error-text">{row.original.remark}</div>
						</div>
					}
					
				</>;
			},
			disableSortBy: true,
		},
		{
			Header: () => {
				return <div className="pull-right">{t("AMOUNT")}</div>;
			},
			accessor: "amount",
			Cell: ({ row }) => {
				return <div className="pull-right">{numberWithCurrencyFormat(parseFloat(row.original.amount))}</div>;
			},
			disableSortBy: true,
		},
		{
			Header: () => {
				return <div className="pull-right">{t("MAIN_WALLET_BEFORE")}</div>;
			},
			accessor: "prePrimaryCreditBalance",
			Cell: ({ row }) => {
				return <div className="pull-right">{row.original.prePrimaryCreditBalance==="-"?"-":numberWithCurrencyFormat(parseFloat(row.original.prePrimaryCreditBalance))}</div>;
			},
			disableSortBy: true,
		},
		{
			Header: () => {
				return <div className="pull-right">{t("MAIN_WALLET_AFTER")}</div>;
			},
			accessor: "postPrimaryCreditBalance",
			Cell: ({ row }) => {
				return <div className="pull-right">{row.original.postPrimaryCreditBalance==="-"?"-":numberWithCurrencyFormat(parseFloat(row.original.postPrimaryCreditBalance))}</div>;
			},
			disableSortBy: true,
		},
		{
			Header: () => {
				return <div className="pull-right">{t("BONUS_AMOUNT")}</div>;
			},
			accessor: "bonusWalletAmount",
			Cell: ({ row }) => {
				return <div className="pull-right">{numberWithCurrencyFormat(parseFloat(row.original.bonusWalletAmount))}</div>;
			},
			disableSortBy: true,
		},
		{
			Header: () => {
				return <div className="pull-right">{t("BONUS_WALLET_BEFORE")}</div>;
			},
			accessor: "preBonusWalletBalance",
			Cell: ({ row }) => {
				return <div className="pull-right">{row.original.preBonusWalletBalance==="-"?"-":numberWithCurrencyFormat(parseFloat(row.original.preBonusWalletBalance))}</div>;
			},
			disableSortBy: true,
		},
		{
			Header: () => {
				return <div className="pull-right">{t("BONUS_WALLET_AFTER")}</div>;
			},
			accessor: "postBonusWalletBalance",
			Cell: ({ row }) => {
				return <div className="pull-right">{row.original.postBonusWalletBalance==="-"?"-":numberWithCurrencyFormat(parseFloat(row.original.postBonusWalletBalance))}</div>;
			},
			disableSortBy: true,
		},
	];

	let _exportHeaders2 = [
		{ label: "Transaction DateTime", key: "transactionDateTime" },
		{ label: "Action", key: "action" },
		{ label: "Amount", key: "amount" },
		{ label: "Account Balance Before", key: "prePrimaryCreditBalance" },
		{ label: "Account Balance After", key: "postPrimaryCreditBalance" },
		{ label: " ", key: " " },
		{ label: "Coins Amount", key: "bonusWalletAmount" },
		{ label: "Coins Before", key: "preBonusWalletBalance" },
		{ label: "Coins After", key: "postBonusWalletBalance" },
		{ label: "Error", key: "remark" },
	];

	useEffect(() => {
		if (memberId) {
			setMemberId(memberId);
			getMemberAccountJourney();
		}
	}, [memberId]);

	const handleEvent = (event, picker) => {
		setStartDate(moment(picker.startDate).format("YYYY-MM-DD HH:mm:ss"));
		setEndDate(moment(picker.endDate).format("YYYY-MM-DD HH:mm:ss"));
	};

	useEffect(() => {
		if (props.username && props.id) {
			setUsername(props.username);
			setMemberId(props.id);
		}
		const queryParams = new URLSearchParams(window.location.search);
		const startdate = queryParams.get('startdate') || "";
		const enddate = queryParams.get('enddate') || "";
		const username = queryParams.get('username') || "";
		const memberId = queryParams.get('memberId') || "";
	
	
		
		if(!stringIsNullOrEmpty(startdate)){
		  setStartDate(startdate);
		}
		if(!stringIsNullOrEmpty(enddate)){
		  setEndDate(enddate);
		}
		if(!stringIsNullOrEmpty(username)){
		  setUsername(username);
		}
		if(!stringIsNullOrEmpty(memberId)){
		  setMemberId(memberId);
		}
	}, []); 
	const updateSearchParams = () => {
		const params = new URLSearchParams(window.location.search);
	
		if (!stringIsNullOrEmpty(startDate)) {
			params.set('startdate', startDate);
		}
	
		if (!stringIsNullOrEmpty(endDate)) {
			params.set('enddate', endDate);
		}
	
		_history.replace({ search: params.toString() });
	};

	const getMemberAccountJourney = async () => {
		updateSearchParams();
		try {
			var apiUrl =
				ApiUrl._API_GET_MEMBER_ACCOUNT_BALANCE_JOURNEY_REPORT +
				"?startDate=" +
				startDate +
				"&endDate=" +
				endDate;

			apiUrl += "&id=" + memberId;

			var responseJson = await ApiEngine.get(apiUrl);

			if (responseJson[ApiKey._API_SUCCESS_KEY]) {
				setReportData(responseJson[ApiKey._API_DATA_KEY]);
				setExportDatas2(responseJson[ApiKey._API_DATA_KEY]);
			} else {
				throw responseJson[ApiKey._API_MESSAGE_KEY];
			}
		} catch (error) {
			_dispatch(showMessage(false, t(error)));
		}
	};
	
	return (
		<div>
			<form>
				<Panel>
					<PanelBody>
						<div className="row">
							<div className="col-lg-12">
								<div className="row">
									<div className="col-lg-3">
										<div className="form-group">
											<label>
												<b>{t("DATE")}</b>
											</label>
											<div
												className="input-group"
												style={{ width: "100%", flexFlow: "nowrap" }}
											>
												<div className="input-group-prepend">
													<span className="input-group-text">
														<i className="fa fa-calendar"></i>
													</span>
												</div>
												<div style={{ width: "80%" }}>
													<DateRangePicker
														containerStyles={{ width: "100%" }}
														startDate={startDate}
														endDate={endDate}
														onApply={handleEvent}
														alwaysShowCalendars={true}
														locale={{ format: "YYYY-MM-DD HH:mm:ss" }}
														timePicker={true}
														timePickerSeconds={true}
														ranges={{
															Today: [
																moment().startOf("day"),
																moment().endOf("day"),
															],
															Yesterday: [
																moment().subtract(1, "days").startOf("day"),
																moment().subtract(1, "days").endOf("day"),
															],
															"Last 7 Days": [
																moment().subtract(6, "days").startOf("day"),
																moment().endOf("day"),
															],
															"Last 30 Days": [
																moment().subtract(29, "days").startOf("day"),
																moment().endOf("day"),
															],
															"This Month": [
																moment().startOf("month"),
																moment().endOf("month"),
															],
															"Last Month": [
																moment().subtract(1, "month").startOf("month"),
																moment().subtract(1, "month").endOf("month"),
															],
															"This Year": [
																moment().startOf("year"),
																moment().endOf("year"),
															],
														}}
													>
														<input
															type="text"
															className="form-control"
															value={startDate + " - " + endDate}
														/>
													</DateRangePicker>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="row">
									<div className="col-lg-2">
										<button
											type="button"
											style={{ marginLeft: "5px" }}
											className="btn btn-primary"
											onClick={() => getMemberAccountJourney()}
										>
											{t("SEARCH")}
										</button>
									</div>
								</div>
							</div>
						</div>
					</PanelBody>
				</Panel>
				<Panel>
					<ReactTable
						data={reportData}
						columns={_tableColumns}
						// renderFooter={true} //footer is not used, not passing any footer from _tableColumns
						defaultSortBy={[
							{
							  id: 'transactionDateTime', // Replace with your column id
							  desc: true, // Set to true for descending order
							},]}
					/>
				</Panel>
			</form>
		</div>
	);
};

export default MemberAccountJourney;
